var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.39644 7.58211L0.14644 4.33211C-0.0488135 4.13686 -0.0488135 3.82028 0.14644 3.625L0.85353 2.91789C1.04878 2.72262 1.36539 2.72262 1.56064 2.91789L3.75 5.10723L8.43935 0.417894C8.6346 0.22264 8.95121 0.22264 9.14646 0.417894L9.85355 1.125C10.0488 1.32026 10.0488 1.63684 9.85355 1.83211L4.10355 7.58213C3.90828 7.77739 3.59169 7.77739 3.39644 7.58211Z",
    fill: "#2253F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.ba5210a4.svg";
export { ForwardRef as ReactComponent };